import { render, staticRenderFns } from "./GeneratedReports.vue?vue&type=template&id=018b934a"
import script from "./GeneratedReports.vue?vue&type=script&lang=js"
export * from "./GeneratedReports.vue?vue&type=script&lang=js"
import style0 from "./GeneratedReports.vue?vue&type=style&index=0&id=018b934a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports